import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

import ChangePassword from '../ChangePassword/ChangePassword';
import ForgotPassword from '../ForgotPassword/ForgotPassword';

import closeIcon from '../../../../../Assets/images/close-icon.svg';
import nextIcon from '../../../../../Assets/images/next-icon.svg';

import { isValidEmail } from '../../../../../Utils/Validations/validateEmail';
import Loader from '../../../../../Context/Loader/Loader';
import { store } from '../../../../../Services/localStorageService';
import { FIELD_MAX_LENGTHS } from '../../Utils/Constants';
import { showErrorToast } from '../../../../../Context/Toaster/Toaster';
import { getFirstPermittedRoute } from '../../Services/NavigationList';

const basePath = process.env.REACT_APP_SERVER_BASE_URL;
const signInPath = process.env.REACT_APP_TC_SIGNIN_BASE_PATH;

const SignInForm = ({ onClose, onOpenSignup }) => {
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
    const [showForgot, setShowForgot] = useState(false);
    const [userId, setUserId] = useState(null);

    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: '' }));
    };

    const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

    const validate = () => {
        const newErrors = {};
        const { email, password } = formData;

        if (!email || !email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!isValidEmail(email)) {
            newErrors.email = 'Enter a valid email';
        }

        if (!password) {
            newErrors.password = 'Password is required';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;
        setLoading(true);

        try {
            const response = await axios.post(`${basePath}${signInPath}/login`, formData);

            if (response.data.status === 'SUCCESS') {
                const { access_token, refresh_token, change_password_required, data } = response.data;

                const accessDecoded = jwtDecode(access_token);
                store('accessToken', access_token);
                store('accessTokenExpiry', accessDecoded.exp * 1000);
                store('userRole', accessDecoded.role);

                const refreshDecoded = jwtDecode(refresh_token);
                store('refreshToken', refresh_token);
                store('refreshTokenExpiry', refreshDecoded.exp * 1000);

                if (change_password_required) {
                    setUserId(data?.user?.id);
                    setShowChangePasswordModal(true);
                } else {
                    const firstPath = getFirstPermittedRoute();
                    if (firstPath) {
                        navigate(firstPath);
                    } else {
                        navigate("/access-denied")
                    }
                }
            } else {
                showErrorToast((prev) => ({ ...prev, email: response.data.message }));
            }
        } catch (err) {
            const msg = err.response ? err.response.data.message : err.message;
            console.error(msg);
            showErrorToast(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {!showChangePasswordModal && !showForgot && (
                <div className="form-cvr" id="contentDiv">
                    <div className="h-form signin-form" id="myDiv" style={{ position: 'relative' }}>
                        <button className="close-button" onClick={onClose}>
                            <img src={closeIcon} alt="Close" />
                        </button>
                        <h1>Welcome to HaulSync</h1>
                        <h2>Sign In to</h2>
                        <p>Truck Company</p>

                        <form className="hform-inner-small" onSubmit={handleSubmit}>
                            <div className="hf-split c-name" style={{ position: 'relative' }}>
                                <label className="fi-label">Email</label>
                                <input type="text" className={`common-input ${errors.email ? 'error' : ''}`} name="email" value={formData.email} onChange={handleChange} maxLength={FIELD_MAX_LENGTHS.email} />
                                <span className={`error-text ${errors.email ? 'active' : ''}`}>
                                    {errors.email || ' '}
                                </span>
                            </div>

                            <div className="hf-split c-name" style={{ position: 'relative' }}>
                                <label className="fi-label">Password</label>
                                <div className="password-box" style={{ position: 'relative' }}>
                                    <input type={showPassword ? 'text' : 'password'} className={`common-input ${errors.password ? 'error' : ''}`} name="password" value={formData.password} onChange={handleChange} maxLength={FIELD_MAX_LENGTHS.password} />
                                    <i className={`fa field-icon ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`} onClick={togglePasswordVisibility} style={{ position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)', cursor: 'pointer', }} />
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', position: 'relative' }}>
                                    <span className={`error-text ${errors.password ? 'active' : ''}`} style={{ flex: 1 }}>
                                        {errors.password || ' '}
                                    </span>
                                    <a className="forgot-link" href="#" onClick={(e) => { e.preventDefault(); setShowForgot(true); }} style={{ position: 'absolute', right: 0 }}>
                                        Forgot Password?
                                    </a>
                                </div>
                            </div>

                            <div className="field login-btns">
                                <button type="submit" className="firstNext next h-btn" disabled={loading}>
                                    {loading ? <Loader /> : <>Sign In <img src={nextIcon} alt="Next" /></>}
                                </button>
                                <p className="ins-text lins">
                                    Don't have an account yet?{' '}
                                    <a href="#" onClick={(e) => { e.preventDefault(); onOpenSignup(); }}>
                                        Sign Up
                                    </a>
                                </p>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {showChangePasswordModal && (
                <ChangePassword
                    userId={userId}
                />
            )}

            {showForgot && (
                <ForgotPassword
                    onClose={() => setShowForgot(false)}
                    onConfirmClose={() => {
                        setShowForgot(false);
                        onClose();
                    }}
                />
            )}
        </>
    );
};

export default SignInForm;